export function logTime() {
  const now = new Date()
  const msec = now.getMilliseconds().toString().padStart(3, '0')
  const timeFormat = now.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }) + '.' + msec
  return timeFormat
}
